import { Accordion, Card, Heading, Paragraph } from '@zillow/constellation-10';
import { OutstandingBalanceItems } from './OutstandingBalanceItems.component';
import { LateRentModel } from '@renter-hub/models/Types';

type Props = {
  transactions: LateRentModel[];
  payLateRentPaymentOnClick: (scheduleMonth: string) => void;
};

export const OutstandingBalanceCard = (props: Props) => (
  <Card
    css={{ padding: 'token(spacing.sm) !important', marginBottom: 'token(spacing.md) !important' }}
    elevated={false}
  >
    <Heading level={3} textStyle="heading-xs">
      Outstanding Balance
    </Heading>
    <Paragraph css={{ marginBottom: 'token(spacing.md) !important', marginTop: 'token(spacing.sm) !important' }}>
      You have a payment that is past due
    </Paragraph>
    <Accordion.Root>
      <Accordion.Item value="outsanding-balance-accordion">
        <Accordion.Header css={{ padding: '12px 16px !important' }}>
          <Heading level={6}>Your past due payments</Heading>
        </Accordion.Header>
        <Accordion.Panel css={{ padding: '12px 16px !important' }}>
          <OutstandingBalanceItems
            transactions={props.transactions}
            payLateRentPaymentOnClick={props.payLateRentPaymentOnClick}
          />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  </Card>
);
